// extracted by mini-css-extract-plugin
export var planCard = "_vd-0";
export var planList = "_vd-1";